import { PULSE_VIEW_ID } from './pulseViewIds';
import {
  PULSE_CLICK_ACTION,
  trackCartPageClick,
  trackCheckoutPageClick,
} from './pulseClickIds';

/** Pick-up slot modal → switch to delivery (cart vs checkout context). */
export const trackSwitchDeliveryClick = ({
  isCartOpen,
  page_path,
}: {
  isCartOpen: boolean;
  page_path?: string;
}): void => {
  const clickArgs = {
    action: PULSE_CLICK_ACTION.TAP_SWITCH_DELIVERY,
    label: null as string | null,
    page_path,
  };

  if (isCartOpen) {
    trackCartPageClick(clickArgs);
    return;
  }

  trackCheckoutPageClick({
    ...clickArgs,
    view_id: PULSE_VIEW_ID.CAPACITY_SELECTOR_MODAL,
  });
};

/** Delivery slot modal → switch to pick-up (cart vs checkout context). */
export const trackSwitchPickupClick = ({
  isCartOpen,
  page_path,
}: {
  isCartOpen: boolean;
  page_path?: string;
}): void => {
  const clickArgs = {
    action: PULSE_CLICK_ACTION.TAP_SWITCH_PICKUP,
    label: null as string | null,
    page_path,
  };

  if (isCartOpen) {
    trackCartPageClick(clickArgs);
    return;
  }

  trackCheckoutPageClick({
    ...clickArgs,
    view_id: PULSE_VIEW_ID.CAPACITY_SELECTOR_MODAL,
  });
};
